import { Injectable } from '@angular/core';
import { Result } from '../state-management/model/interfaces/state.model';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private logger: LoggerService) { }

  public fail<E>(error: E, code: number): Result<never, E> {
    this.logger.error("An error occured:", error);
    return { success: false, error: error, code: code };
  }
  
  public ok<T>(payload: T, warning?: string, code?: number): Result<T, never> {
    return warning ? { success: true, payload, warning, code: code || 201 } : { success: true, payload, code: 200 };
  }

  public deepMergeWithDefaults<T extends Record<string, any>>(data: Partial<T>, defaults: T): T {
    const result = { ...defaults };

    Object.keys(defaults).forEach(key => {
      const typedKey = key as keyof T;

      if (
        typeof defaults[typedKey] === 'object' &&
        defaults[typedKey] !== null &&
        !Array.isArray(defaults[typedKey])
      ) {
        // Only merge if both data and defaults are objects
        if (typeof data[typedKey] === 'object' && data[typedKey] !== null) {
          result[typedKey] = this.deepMergeWithDefaults(
            data[typedKey] as Partial<T[keyof T]>,
            defaults[typedKey] as T[keyof T] & Record<string, any>
          ) as T[keyof T];
        } else {
          result[typedKey] = defaults[typedKey] as T[keyof T];
        }
      } else {
        // Use the provided data value or default if not set
        result[typedKey] = data[typedKey] !== undefined ? data[typedKey] as T[keyof T] : defaults[typedKey];
      }
    });

    return result;
  }



}
